module.exports = __webpack_public_path__ + "img/btn-subir.8d5ed0e5.png";